// extracted by mini-css-extract-plugin
export var closeButton = "_ac-0";